import React, { useEffect, useState } from 'react';
import './overview.css';

const LinkedUnLinkedShow = (props:any) => {
    const [effectiveToDate, setEffectiveToDate] = useState<any>('');
    const [effectiveFromDate, setEffectiveFromDate] = useState<any>('');
    const [formattedCurrentDate, setFormattedCurrentDate] = useState<any>('');

    useEffect(() => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();

        const toDate = props.user.effective_to_dt !== '-----' ? new Date(props.user.effective_to_dt.split('-').reverse().join('-')) : null;
        const fromDate = props.user.effective_from_dt !== '-----' ? new Date(props.user.effective_from_dt.split('-').reverse().join('-')) : null;
        const presentDate = new Date(`${year}-${month}-${day}`);

        setEffectiveToDate(toDate);
        setEffectiveFromDate(fromDate);
        setFormattedCurrentDate(presentDate);
    }, [props.user]);

    let statusClass = '';
    let label = '';

    if (props.user.isParent) {
        statusClass = 'parent';
        label = 'Parent Facility';
    } else if ((props.user.effective_to_dt === '-----' && effectiveFromDate <= formattedCurrentDate) || effectiveToDate >= formattedCurrentDate) {
        statusClass = 'linked';
        label = 'Linked';
    } else {
        statusClass = 'unlinked';
        label = 'Unlinked';
    }

    return (
        <div className="link_unlink_container">
            <div>
                {props.user.facility_name.value}
            </div>
            <div className={`link_unlink_status ${statusClass}`}>
                {label}
            </div>
        </div>
    );
}

export default LinkedUnLinkedShow;
